import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  getOffers,
  deleteOffer,
  getYearsForOffers,
  sendOfferToEmail,
  updateOfferStatusById,
  generatePdf
} from "../modules/actions";
import { getSuppliers } from "../../Dobavljaci/modules/actions";

const mapStateToProps = (state) => ({
  state: {
    loggedUser: state.user.loggedUser,
    offers: state.offersReducer.offers,
    suppliers: state.suppliersReducer.suppliers,
    years: state.offersReducer.years,
  },
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      getOffers,
      getSuppliers,
      deleteOffer,
      getYearsForOffers,
      sendOfferToEmail,
      updateOfferStatusById,
      generatePdf
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps);
